
export enum PickupTimeTerm {
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  PAST_DAYS = 'PAST_DAYS',
}
